<template>
  <div class="content-slider__slider | slider">
    <a class="content-slide | block-animation >> start__fade-out--full-50 end__fade-in--50-full" v-for="(block, index) in items" v-bind:key="'block-'+index"
      :aria-label="block.header"
      :href="block.contentLinkUrl"
      :target="block.contentLinkTarget">
      <div class="content-card bg-white">
        <div class="content-slide__media">
          <div class="image | -is1x1 -fit-cover bg-ivory-lightest">
            <img :data-src="block.imageUrl" class="tns-lazy-img" />
          </div>
        </div>

        <div class="content-card__content">
          <div class="content-card__header">
            <h6 class="header | header-sm font-medium">{{ block.header }}</h6>
          </div>
          <div class="content-card__action">
            <span class="content-card__action-text | link -grey -arrow-tilt-right -wide | text-xs">
              {{ block.contentLinkText }}
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider";
// import arrow_icon from "../icons/arrow";
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    startSlider() {
      const _this = this;
      const sliderEl = _this.$el;
      var slider = tns({
        container: sliderEl,
        controls: false,
        nav: false,

        slideBy: 1,
        items: 3,
        gutter: 24,
        autoHeight: false,
        fixedWidth: 258,
        mouseDrag: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        lazyload: true
      });

      // slider.updateSliderHeight();
    }
  },
  mounted() {
    this.startSlider();
  }
};
</script>